

import axios from '../../API/axios';

import {
  FETCH_CURRENCY_REQUEST,
  FETCH_CURRENCY_SUCCESS,
  FETCH_CURRENCY_FAILURE,
  SET_SELECTED_CURRENCY ,
} from '../types'; 

// Fetch Work Level Types
export const fetchCurrency = () => async (dispatch) => {
  dispatch({ type: FETCH_CURRENCY_REQUEST });
  
  try {
    const response = await axios.get('MasterDDL/GetCurrenciesDDL');
    // console.log("currency", response);
    
    const currencyOptions = response.data.responseData.map((val) => ({
        value: val.id,
        label: val.name,
    }));
    
    dispatch({
      type: FETCH_CURRENCY_SUCCESS,
      payload: currencyOptions,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CURRENCY_FAILURE,
      payload: error.message,
    });
  }
};
 
export const selectWorkLevel = (id) => ({
  type: SET_SELECTED_CURRENCY,
  payload: id,
});

